import dayjs from 'dayjs';

// Currency key mapping for resolving prices
export const currencyKeyMap = {
  1: 'USD',
  2: 'SYP',
  3: 'EUR',
};

// Helper to resolve price for a given currency id (1 => USD, 2 => SYP, 3 => EUR)
export const getPriceForCurrency = (prices, currencyId) => {
  if (!prices || currencyId == null) return null;

  // prices is a dictionary object from the backend
  // Try by numeric key first (e.g. "1", "2")
  const numericKey = prices[currencyId];
  if (numericKey) return numericKey;

  // Then try by enum name (e.g. "USD", "SYP")
  const nameKey = currencyKeyMap[currencyId] && prices[currencyKeyMap[currencyId]];
  if (nameKey) return nameKey;

  return null;
};

// Calculate unit price for a material
export const calcUnitPrice = ({ materialPrices, materialId, currencyId }) => {
  let unitPrice = 0;

  if (materialId) {
    const priceInfo = materialPrices.find(p => p.materialId === materialId);
    if (priceInfo) {
      const pricesObj = priceInfo.prices || priceInfo.Prices || {};
      const priceForCurrency = getPriceForCurrency(pricesObj, currencyId);

      if (priceForCurrency) {
        if (priceForCurrency.unitPrice != null) {
          unitPrice = priceForCurrency.unitPrice;
        } else if (priceForCurrency.retailPrice != null) {
          unitPrice = priceForCurrency.retailPrice;
        }
      }
    }
  }

  return unitPrice || 0;
};

// Format date using dayjs
export const formatDate = (date) => date ? dayjs(date).format('YYYY-MM-DD') : '';

// Format currency
export const formatCurrency = (value) => `$${value}`;

// Base account IDs
export const BASE_ACCOUNTS = {
  CLIENTS: 12,
  RESOURCES: 21,
  CASH: 11,
};
